import axios from 'axios'
import { deleteDB } from 'idb'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Image from "../images/Picture2.png"
const FlushData = ({ onClose }) => {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const SimpleLogout = async () => {
        setLoading(true)
        let data = {
            outlet_uuid: localStorage.getItem("outlet_uuid"),
            categories: "Y",
            items: "Y",
            menus: "Y",
            orders: "Y",
            seats: "Y",
            sections: "Y",
            remove_flush: "Y"
        }
        let response = await axios({
            method: "post",
            url: "https://api.myfooddo.com/FlushOutletData",
            data
        })
        if (response.data.success) {
            sessionStorage.clear();
            localStorage.clear();
            await deleteDB(
                "FoodDo",
                +localStorage.getItem("IDBVersion") || 1
                , {
                    blocked() {
                        console.log("Blocked!!")
                    },
                });
            setLoading(false)
            navigate("/login")
            onClose()
        }
        console.log(response)
    }
    return (
        <div className="logoutPopup">
            <div className="logout_content">
                <img src={Image} style={{width:"500px"}} alt='fooddo'/>
                <div className="logout_button">
                    <div className="button_container">
                        {!loading ? (
                            <button className="simple_Logout_button" onClick={SimpleLogout}>
                                Okay
                            </button>
                        ) : (
                            <button className="clear_Logout_button" id="loading-screen">
                                <svg viewBox="0 0 100 100">
                                    <path
                                        d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                                        fill="#ffffff"
                                        stroke="none"
                                    >
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            dur="1s"
                                            repeatCount="indefinite"
                                            keyTimes="0;1"
                                            values="0 50 51;360 50 51"
                                        ></animateTransform>
                                    </path>
                                </svg>
                            </button>
                        )}

                    </div>
                    <div className="button_container">

                        <button
                            className="clear_Logout_button"
                            style={{ background: "red" }}
                            onClick={onClose}
                        >
                            Cancel
                        </button>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlushData